import router from '@/router'
const logout = () => {
  localStorage.removeItem("getUser");
  localStorage.removeItem("AuthenticationResult");
  localStorage.setItem("Auth", "false");
  router.go("");
}
export default logout;